/*
 *   File : goal-card.js
 *   Author : https://evoqins.com
 *   Description : goal card component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React from "react";
import Icon from "../icons";

export default function GoalCard({ title, img, onClick }) {
  return (
    <div
      onClick={onClick}
      className="e-goal-card w-100 border border-white h-100  p-3 rounded-16 d-flex rg-14"
    >
      <div className="d-flex justify-content-between w-100">
        <div className="d-flex flex-column rg-12">
          <div className=" e-w-fit rounded-8 bg-white e-border border-facebook-blue-4 border-opacity-10 p-1">
            <img src={img} alt={title} width={44} />
          </div>
          <h5 className="mb-0 fw-400 fs-16 lh-20 text-eerie-black">{title}</h5>
        </div>
        <div className="d-flex flex-column justify-content-center ">
          <Icon
            icon="chevron-right"
            size={14}
            className="text-facebook-blue e-goal-icon opacity-100 e-cursor-pointer"
          />
        </div>
      </div>
    </div>
  );
}
